import { z } from 'zod';

export const impostoInputSchema = z.object({
  tipo: z.enum(['COFINS', 'CSLL', 'INSS', 'IRRF', 'PIS', 'ISS']),
  regraMunicipal: z.enum(['MES', 'OUT', 'AMB']).nullable().optional(),
  // Alíquota é **percentual direto** (3 = 3%, 0.5 = 0,5%). GeneXus armazena
  // assim em todo o sistema; o front não multiplica/divide por 100.
  // Numeric(8,4) → até 9999.9999, mas alíquotas reais raramente passam de 100%.
  aliquota: z
    .number()
    .min(0, 'Alíquota mínima 0')
    .max(100, 'Alíquota máxima 100%')
    .refine((n) => Number.isFinite(n) && Math.round(n * 10000) === n * 10000, {
      message: 'Máximo 4 casas decimais',
    }),
  nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  retido: z.boolean(),
  empresaId: z.number().int().positive('Empresa obrigatória'),
  enviarValor: z.boolean(),
  enviarAliquota: z.boolean(),
  ativo: z.boolean().optional(),
});

export type ImpostoFormValues = z.infer<typeof impostoInputSchema>;
